import React from 'react';
import OrangeButton from '../Components/buttons/orange-button';
import { Link } from 'react-router-dom';

const CreateAccount = () => {
  return (
    <div className="min-h-screen bg-greenColor py-6">
      <div className="container flex flex-col gap-4">
        <Link to={'/'} className="logo nav-logo-title !text-[#fff]">
          <img src="/images/icons/grad-img.svg" alt="grad" />
          IAMAI
        </Link>
        <div className="flex h-full w-full items-center justify-center">
          <div className="flex w-full max-w-md flex-col gap-4 rounded-[16px] bg-white p-4 shadow-lg md:p-8">
            <h2 className="fredokaOne text-center text-[40px] font-normal leading-normal tracking-[-0.8px] text-[#012E33]">
              Create an Account
            </h2>
            <form>
              <div className="mb-4">
                <input
                  type="text"
                  id="username"
                  placeholder="Username"
                  className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-3 outline-none"
                />
              </div>
              <div className="mb-4">
                <input
                  type="text"
                  id="firstName"
                  placeholder="First Name"
                  className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-3 outline-none"
                />
              </div>
              <div className="mb-4">
                <input
                  type="text"
                  id="lastName"
                  placeholder="Last Name"
                  className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-3 outline-none"
                />
              </div>
              <div className="mb-4">
                <input
                  type="email"
                  id="email"
                  placeholder="Enter Email"
                  className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-3 outline-none"
                />
              </div>
              <div className="mb-4">
                <input
                  type="password"
                  id="password"
                  placeholder="Password"
                  className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-3 outline-none"
                />
              </div>
              <OrangeButton label={'Sign Up'} className="w-full" />
            </form>
            <p className="text-center text-[16px] font-semibold leading-normal tracking-[-0.32px] text-[#012E33]">
              Or continue using:
            </p>
            <div className="text-center">
              <div className="flex flex-wrap justify-center gap-3 md:flex-nowrap">
                <button
                  className={`fredoka mx-auto flex h-12 w-full items-center justify-center rounded-2xl bg-[#4285F4] px-6 py-2 font-[Fredoka] text-[16px] text-base font-medium leading-normal text-white  shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset]`}
                >
                  <img src="/images/icons/social-icons/FacebookLogo.svg" alt="" /> Facebook
                </button>
                <button
                  className={` fredoka  mx-auto flex h-12 w-full items-center justify-center rounded-2xl bg-[#DC4E41] px-6 py-2 font-[Fredoka] text-[16px] text-base font-medium leading-normal text-white  shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset]`}
                >
                  <img src="/images/icons/social-icons/GoogleLogo.svg" alt="" /> Google
                </button>
                <button
                  className={` bg-[#000000] w-full h-12 mx-auto rounded-2xl shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] px-6 py-2 flex justify-center items-center text-base font-medium leading-none fredoka text-white font-[Fredoka] text-[16px]  leading-normal"
`}
                >
                  <img src="/images/icons/social-icons/AppleLogo.svg" alt="" /> Apple
                </button>
              </div>
              <p className="mt-4 space-x-2 text-gray-700">
                <span className="text-center font-[Fredoka] text-[16px] font-semibold leading-normal tracking-[-0.32px] text-[#012E33]">
                  No Account?
                </span>
                <a
                  href="#"
                  className="font-[Fredoka] text-[16px] font-semibold leading-normal tracking-[-0.32px] text-[#FC823E] underline decoration-[#FC823E] decoration-solid decoration-0 underline-offset-auto"
                >
                  Create One
                </a>
              </p>
              <p className="mt-2 text-gray-700">
                <a
                  href="#"
                  className="text-center font-[Fredoka] text-[16px] font-semibold leading-normal tracking-[-0.32px] text-[#FC823E] underline decoration-solid decoration-0 underline-offset-auto"
                >
                  Forgot Password?
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
